// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 16:56:31

export default {
  "id": "triple-tile-twister-match-game",
  "slug": "triple-tile-twister-match-game",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/33db73b835a8497995d94f7f62f77b75-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/33db73b835a8497995d94f7f62f77b75/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Triple Tile Twister Match Game",
      "description": "Triple Tile Twister: Match Game is a relaxing puzzle with a twist on mahjong. Clear the board by matching groups of three identical tiles. ?✨ Strategically select tiles to move to the holding area, which holds up to 7 tiles. Create sets of three to clear them, but watch out! ? If the area fills with unmatched tiles, the game ends. Enjoy soothing graphics and relaxing gameplay—perfect for unwinding! ? Great for both mahjong fans and newcomers! ?",
      "instructions": "Tap on tile to collect them, clear the board and win the level",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "match3",
        "matching",
        "relaxing",
        "tiles"
      ]
    },
    "zh-CN": {
      "title": "三倍瓷砖扭曲匹配游戏",
      "description": "三联瓷砖扭动：匹配游戏是一款轻松的拼图游戏，结合了麻将的元素。通过匹配三张相同的瓷砖来清理棋盘。✨策略性地选择瓷砖移动到最多可容纳7张瓷砖的暂存区，创建三联组来清除它们，但要注意！？如果区域被未匹配的瓷砖填满，游戏结束。享受舒缓的图形和轻松的游戏玩法——完美放松！？适合麻将爱好者和新手！？",
      "instructions": "点击瓷砖收集它们，清除游戏板并赢得关卡",
      "genres": [
        "拼图"
      ],
      "tags": [
        "三消",
        "匹配",
        "轻松",
        "拼图"
      ]
    },
    "zh-TW": {
      "title": "三倍拼圖捲曲配對遊戲",
      "description": "三合板旋風：對決遊戲是一款結合了麻將風格的放鬆益智遊戲。透過匹配三組相同的 tile 清空遊戲板。✨ 策略性地選擇 tile 並將其移至可存放至多7 tile 的擁有區，創建三組以清空它們，但注意！？ 如果區域內填滿未匹配的 tile，遊戲即結束。享受舒緩的圖形和放鬆的遊戲玩法——完美適合放鬆！？ 非常適合麻將愛好者和新玩家！？",
      "instructions": "點擊圖塊以收集它們，清空遊戲板並贏得關卡",
      "genres": [
        "謎題"
      ],
      "tags": [
        "match3",
        "配對",
        "放鬆",
        "拼圖"
      ]
    },
    "zh-HK": {
      "title": "三合板旋轉配對遊戲",
      "description": "三合瓷砖扭動：匹配遊戲是一款結合了馬賈棋元素的輕鬆拼圖遊戲。通過匹配三個相同的瓷砖來清空遊戲版。✨策略性地選擇瓷砖移動到最多可存放7個瓷砖的暫存區，組成三合組合來清空它們，但注意！如果區域被未匹配的瓷砖填滿，遊戲即結束。享受寧靜的圖像和輕鬆的遊戲過程——完美釋放壓力！適合馬賈棋愛好者和新進者！",
      "instructions": "按鍵收集圖塊，清空遊戲板，獲勝通關",
      "genres": [
        "謎題"
      ],
      "tags": [
        "三消遊戲",
        "匹配",
        "輕鬆",
        "圖塊"
      ]
    },
    "ja": {
      "title": "トリプルタイルツイストマッチゲーム",
      "description": "トリプルタイルツイスターメッチゲームは、マージャンの要素を取り入れたリラックスしたパズルゲームです。同じタイルの3つをマッチしてボードをクリアしましょう。✨ 持続エリアに移動するタイルを選択する戦略を立ててください。持続エリアは最大7タイルを保持できます。3つのセットを作成してクリアすると、それらを消去できますが、注意してください！持続エリアが一致しないタイルで満たされると、ゲームが終了します。落ち着いたグラフィックとリラックスしたゲームプレイを楽しみましょう—リラックスするのに最適です！マージャンファンと初心者にもおすすめです！",
      "instructions": "タイルをタップして収集し、ボードをクリアしてレベルをクリアする",
      "genres": [
        "パズル"
      ],
      "tags": [
        "マッチ3",
        "一致",
        "リラックス",
        "タイル"
      ]
    },
    "ko": {
      "title": "트리플 타일 트위스터 매치 게임",
      "description": "트리플 타일 트위스터: 매치 게임은 마주교의 변신을 담은 편안한 패uzzle 게임입니다. 세 개의 같은 타일을 맞춰 보드를 클리어하세요. ?✨ 7개까지 저장할 수 있는 holding area로 타일을 이동하여 전략적으로 선택하세요. 세 개의 세트를 만들어 클리어하세요, 하지만 주의하세요! ? 불일치 타일로 area가 가득 차면 게임이 끝납니다. 편안한 그래픽과 편안한 게임 플레이를 즐겨보세요—대단히 휴식이 됩니다! ? 마주교 팬과 신입 모두에게 great합니다! ?",
      "instructions": "타일을 탭하여 수집하고, 보드를 비우고 레벨을 승리하세요",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "매치3",
        "매칭",
        "쉬운",
        "타일"
      ]
    },
    "fr": {
      "title": "Triple Tile Twister Match Game\nJeu de correspondance Triple Tile Twister",
      "description": "Triple Tile Twister: Match Game est un puzzle apaisant avec une touche de mahjong. Nettoyez le plateau en formant des groupes de trois tuiles identiques. ?✨ Sélectionnez stratégiquement les tuiles à déplacer dans la zone de conservation, qui peut contenir jusqu'à 7 tuiles. Créez des ensembles de trois pour les éliminer, mais faites attention ! ? Si la zone se remplit de tuiles non correspondantes, la partie se termine. Profitez des graphismes apaisants et du gameplay relaxant — parfait pour se détendre ! ? Idéal pour les fans de mahjong et les nouveaux venus ! ?",
      "instructions": "Tapez sur la tuile pour les collecter, nettoyez le plateau et gagnez le niveau",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "match3",
        "correspondance",
        "relaxant",
        "tuiles"
      ]
    }
  }
};
